import { KeycloakService } from "keycloak-angular";
import {AppConfig} from "@app-so/app.config";
import {AuthService, EnvironmentModel, ProfileService} from "@common/generic";
import {UsersApiService} from "@app-so/users/services/users-api.service";
import {User} from "@app-so/users/models/User";
import {StorageService} from "@generic/services/storage.service";
import {storageKeys} from "@app-so/constants";


export function initializeKeycloak(
  keycloak: KeycloakService,
  config: AppConfig,
  profile : ProfileService,
  storageService: StorageService,
): () => Promise<any> {
  const jsonFile = `assets/config.json`;
  //let profile : ProfileService;
  return (): Promise<any> => {
    return new Promise(  (resolve, reject) => {

      try {
        // @ts-ignore
        config.internalhttp.get(jsonFile).toPromise().then((response: EnvironmentModel) => {
          AppConfig.settings = response;
          //  resolve();
          keycloak.init({
            config: {
              url: AppConfig.settings.keycloakEndpoint,//'http://localhost:8080/auth',
              realm: AppConfig.settings.realmName,
              clientId: 'frontend',
            },
            initOptions: {
              onLoad: 'login-required',
              checkLoginIframe: false,
              //idToken: storageService.getItem(storageKeys.auth),
              //refreshToken: storageService.getItem(storageKeys.refreshToken),
            },
            loadUserProfileAtStartUp: false,
            //enableBearerInterceptor: true,
          }).then((isInitialize) => {
            console.log("keycloak is initialized : ", isInitialize);
            console.log("username : ",JSON.stringify(keycloak.getKeycloakInstance().idTokenParsed["preferred_username"]));
            const token = keycloak.getKeycloakInstance().token;
            const headers = {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
              };
            config.internalhttp.post<User>(`${AppConfig.settings.apiEndpoint}/api/getUserById`, {id: keycloak.getKeycloakInstance().idTokenParsed["preferred_username"]},{headers}).toPromise().then(
              userDetails => {
                profile.set({
                  email: userDetails.email,
                  partyId: userDetails.partyId,
                  partyName: userDetails.partyName,
                  role: userDetails.roles,
                  id: userDetails.email,
                  org: userDetails.org,
                  mode: userDetails.mode,
                  configPartyName: userDetails.configPartyName,
                  orgtype: userDetails.orgtype,
                });
                storageService.setItem(storageKeys.auth, keycloak.getKeycloakInstance().idToken);
                storageService.setItem(storageKeys.refreshToken, keycloak.getKeycloakInstance().refreshToken);
                const tokenExpiringDate = Date.now() + <any>keycloak.getKeycloakInstance().idTokenParsed["exp"] * 5000;
                storageService.setItem(storageKeys.authExpiration, JSON.stringify(tokenExpiringDate));
                console.log('response', JSON.stringify(userDetails));
                resolve();
              }).catch(error => {
              console.log("error happened while getting user details  : ", JSON.stringify(error));
              // keycloak.logout();
            });
            //resolve();
            // resolve();
          }).catch(error => {
            console.log("error happened during Keycloak  : ", JSON.stringify(error));
            reject(error);
            // keycloak.logout();
          });
          // resolve();
        }).catch(reason => {
          console.log("error happened during Keycloak config : ", JSON.stringify(reason));
        });
        //getTokenresolve();
      } catch (error) {
        console.log("error happened during Keycloak initialization : ", JSON.stringify(error));
        reject(error);
      }
      // resolve();
    });
  };
}


